import React from 'react'
import CustomInput from '../../../components/CustomInputs/CustomInput'
import { Button } from 'flowbite-react'
import showToast from '../../../components/CustomToast/toastHelper'

interface AddDeliveryFeeProps {
    handleClose: () => void,
    fee:number,
    setInputs:(inputs:any)=>void,
    inputs:any
}
const AddDeliveryFee = ({handleClose, fee, setInputs, inputs}: AddDeliveryFeeProps) => {
  const addFee =()=>{
    showToast("fee added successfully", "success")
    handleClose()
  }
  return (
    <div>
      <p className='font-bold text-green-700'>Add delivery fee</p>
      {/* <CustomInput label='Fee type' name='feeType'/> */}
      <CustomInput label='Enter amount' name='amount' value={fee} onChange={(e)=>setInputs({...inputs, fee:e.target.value})}/>
      <div className='mx-4 flex gap-4'>
        <Button className='w-1/3' outline onClick={handleClose}>Back</Button>
        <Button className='w-2/3 bg-custom-button-green' onClick={()=>addFee()}>Add Fee</Button>
      </div>
    </div>
  )
}

export default AddDeliveryFee
